import ActivityTracker from './ActivityTracker';
import ActUtils from './ActivityUtils';

export default ActivityTracker;
export const ActivityUtils = {
    ...ActUtils
};